import { render, staticRenderFns } from "./Revive.vue?vue&type=template&id=0c15f5fb&scoped=true&"
import script from "./Revive.vue?vue&type=script&lang=ts&"
export * from "./Revive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c15f5fb",
  null
  
)

export default component.exports